// Offertenummers die iemand in de chat noemt ("houd offerte 9756 aan", "zie offertenr. 9438")
// — die worden automatisch referentie-offerte (OffertesGenerator, 4 nov). Alleen met het woord
// "offerte" ervoor: een los getal kan ook een projectnummer of bedrag zijn.
export function offerteNummersUitTekst(tekst) {
  const uit = [];
  const re = /\bofferte(?:nummer|nr\.?)?\s*[#:]?\s*(\d{4,5})\b/gi;
  let m;
  // Genormaliseerd (zonder voorloopnullen): '09756' en '9756' zijn dezelfde offerte.
  while ((m = re.exec(String(tekst || ''))) !== null) uit.push(String(Number(m[1])));
  return uit;
}
